import api from './axios';

export const downloadTeamIdCard = async (teamId: string) => {
  const response = await api.get<Blob>(`/api/v1/idcards/team/${teamId}`, {
    responseType: 'blob',
  });
  return response.data;
};

export const downloadPlayerIdCard = async (playerId: string) => {
  const response = await api.get<Blob>(`/api/v1/idcards/player/${playerId}`, {
    responseType: 'blob',
  });
  return response.data;
};
